import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthBrandingComponent } from './components/auth-branding/auth-branding.component';

@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports: [RouterModule, AuthBrandingComponent],
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthLayoutComponent {}
